module.exports = new (function() {
    var SELECTED_USERNAME_KEY = "UsernameCache";

    this.setUsernameForHost = function(username, hostname) {
        // Get the object from localStorage, if not existing then create as an empty object
        var users = localStorage.getObject(SELECTED_USERNAME_KEY) || {};

        // Set this hostname and username value to the object
        users[hostname] = username;

        // Set back to localStorage
        localStorage.setObject(SELECTED_USERNAME_KEY, users);
    };

    this.getUsernameForHost = function(hostname) {
        // Get the object from localStorage
        var users = localStorage.getObject(SELECTED_USERNAME_KEY);

        if (!users) {
            // Does not exist -> return empty string
            return "";
        }

        // Get the username for this host and return
        return users[hostname] || "";
    };

    this.removeUsernameForHost = function(hostname) {
        var users = localStorage.getObject(SELECTED_USERNAME_KEY);

        if (users) { // If object exists, remove the username for this host from it
            delete users[hostname];

            // If users object is now empty, then remove the item from localStorage
            if (jQuery.isEmptyObject(users)) {
                localStorage.removeItem(SELECTED_USERNAME_KEY);
            } else {
                // Still has usernames for other hosts so put back in localStorage
                localStorage.setObject(SELECTED_USERNAME_KEY, users);
            }
        }
    };
})();


//////////////////
// WEBPACK FOOTER
// ./logon/UserCache.js
// module id = 39
// module chunks = 0 3